function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.35207 2.56004C1.95178 2.56004 0 4.51182 0 6.91211V26.8804C0 29.2807 1.95178 31.2325 4.35207 31.2325H14.1447C14.4263 31.2325 14.6567 31.0021 14.6567 30.7205C14.6567 30.4389 14.4263 30.2085 14.1447 30.2085H4.35207C2.51703 30.2085 1.02402 28.7155 1.02402 26.8804V6.91211C1.02402 5.07707 2.51703 3.58406 4.35207 3.58406H6.72062V5.63209C6.72062 5.91369 6.95 6.1441 7.23263 6.1441C7.51423 6.1441 7.74464 5.91369 7.74464 5.63209V3.58406H15.0408V5.63209C15.0408 5.91369 15.2701 6.1441 15.5528 6.1441C15.8344 6.1441 16.0648 5.91369 16.0648 5.63209V3.58406H23.4244V5.63209C23.4244 5.91369 23.6548 6.1441 23.9364 6.1441C24.218 6.1441 24.4484 5.91369 24.4484 5.63209V3.58406H26.8804C28.7155 3.58406 30.2085 5.07707 30.2085 6.91211V14.2082C30.2085 14.4898 30.4389 14.7202 30.7205 14.7202C31.0021 14.7202 31.2325 14.4898 31.2325 14.2082V6.91211C31.2325 4.51182 29.2807 2.56004 26.8804 2.56004H24.4484V0.512008C24.4484 0.230404 24.218 0 23.9364 0C23.6548 0 23.4244 0.230404 23.4244 0.512008V2.56004H16.0648V0.512008C16.0648 0.230404 15.8344 0 15.5528 0C15.2701 0 15.0408 0.230404 15.0408 0.512008V2.56004H7.74464V0.512008C7.74464 0.230404 7.51423 0 7.23263 0C6.95 0 6.72062 0.230404 6.72062 0.512008V2.56004H4.35207Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5127 16.5122H31.9999V32.0002H16.5127V16.5122Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_51:3183)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2563 31.2324C20.4091 31.2324 17.2807 28.103 17.2807 24.2568C17.2807 20.4096 20.4091 17.2802 24.2563 17.2802C28.1035 17.2802 31.2319 20.4096 31.2319 24.2568C31.2319 28.103 28.1035 31.2324 24.2563 31.2324M24.2563 16.5122C19.9862 16.5122 16.5127 19.9867 16.5127 24.2568C16.5127 28.526 19.9862 32.0005 24.2563 32.0005C28.5275 32.0005 31.9999 28.526 31.9999 24.2568C31.9999 19.9867 28.5275 16.5122 24.2563 16.5122",
  fill: "#333333"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2564 21.1201C23.9748 21.1201 23.7444 21.3505 23.7444 21.6321V24.2567C23.7444 24.5383 23.9748 24.7687 24.2564 24.7687H26.1119C26.3945 24.7687 26.6249 24.5383 26.6249 24.2567C26.6249 23.9741 26.3945 23.7447 26.1119 23.7447H24.7684V21.6321C24.7684 21.3505 24.538 21.1201 24.2564 21.1201",
  fill: "#333333"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9365 11.9043C23.5136 11.9043 23.1685 12.2494 23.1685 12.6723C23.1685 13.0952 23.5136 13.4403 23.9365 13.4403C24.3594 13.4403 24.7045 13.0952 24.7045 12.6723C24.7045 12.2494 24.3594 11.9043 23.9365 11.9043",
  fill: "#333333"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3684 11.9043C17.9454 11.9043 17.6003 12.2494 17.6003 12.6723C17.6003 13.0952 17.9454 13.4403 18.3684 13.4403C18.7913 13.4403 19.1364 13.0952 19.1364 12.6723C19.1364 12.2494 18.7913 11.9043 18.3684 11.9043",
  fill: "#333333"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8002 17.4722C12.3773 17.4722 12.0322 17.8173 12.0322 18.2402C12.0322 18.6631 12.3773 19.0082 12.8002 19.0082C13.2232 19.0082 13.5683 18.6631 13.5683 18.2402C13.5683 17.8173 13.2232 17.4722 12.8002 17.4722",
  fill: "#333333"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.23212 11.9043C6.8092 11.9043 6.46411 12.2494 6.46411 12.6723C6.46411 13.0952 6.8092 13.4403 7.23212 13.4403C7.65504 13.4403 8.00014 13.0952 8.00014 12.6723C8.00014 12.2494 7.65504 11.9043 7.23212 11.9043",
  fill: "#333333"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.23212 17.4722C6.8092 17.4722 6.46411 17.8173 6.46411 18.2402C6.46411 18.6631 6.8092 19.0082 7.23212 19.0082C7.65504 19.0082 8.00014 18.6631 8.00014 18.2402C8.00014 17.8173 7.65504 17.4722 7.23212 17.4722",
  fill: "#333333"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.23212 23.0405C6.8092 23.0405 6.46411 23.3856 6.46411 23.8085C6.46411 24.2315 6.8092 24.5766 7.23212 24.5766C7.65504 24.5766 8.00014 24.2315 8.00014 23.8085C8.00014 23.3856 7.65504 23.0405 7.23212 23.0405",
  fill: "#333333"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8002 23.0405C12.3773 23.0405 12.0322 23.3856 12.0322 23.8085C12.0322 24.2315 12.3773 24.5766 12.8002 24.5766C13.2232 24.5766 13.5683 24.2315 13.5683 23.8085C13.5683 23.3856 13.2232 23.0405 12.8002 23.0405",
  fill: "#333333"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8002 11.9043C12.3773 11.9043 12.0322 12.2494 12.0322 12.6723C12.0322 13.0952 12.3773 13.4403 12.8002 13.4403C13.2232 13.4403 13.5683 13.0952 13.5683 12.6723C13.5683 12.2494 13.2232 11.9043 12.8002 11.9043",
  fill: "#333333"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51:3183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 16,
    height: 17
  }, _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Calendar.2750c673.svg";
export { ForwardRef as ReactComponent };